export default {
      id: "wizard-key-usage",
      viewBox: "0 0 44 24",
      url: __webpack_public_path__ + "img/icons.svg#wizard-key",
      toString: function () {
        return this.url;
      }
    }